import React from 'react';
import { Container, Button } from '@mui/material';
import Header from '../components/Header';
import BannerCarousel from '../components/BannerCarousel';
//import Section from './components/Section';
import Player from '../components/Player';
import Post from '../components/Post';
import StaticHtml from '../components/StaticHtml';
import { useNavigate } from 'react-router-dom';


function PostListPage() {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <Container 
        maxWidth='lg'
        // sx={{ padding: 0, margin: 0, }}
        >

        {/* <BannerCarousel /> */}
        <Post />

        
      </Container>
      <Player />
    </>
  );
}

export default PostListPage;